export default __webpack_public_path__ + "static/media/avatar01.abec0e16.svg";